import {combineReducers} from 'redux';
import errorReducer from '../components/bv-scope/BVHeadSign/reducers/errorReducer';
import authReducer from '../components/bv-scope/BVHeadSign/reducers/authReducer';


export default combineReducers({
  error: errorReducer,
  auth:authReducer,
})